/* eslint-disable */
import React from "react";
import Modal from "react-modal";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { Box, Button, Stepper, Typography } from "@mui/material";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import CheckIcon from "@mui/icons-material/Check";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { useNavigate } from "react-router-dom";

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  fontWeight: "bold",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundImage:
      "linear-gradient(0deg, rgba(184,0,200,1) 0%, rgba(161,0,175,1) 43%, rgba(184,0,200,1) 100%);",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundImage:
      "linear-gradient(0deg, rgba(21, 104, 60 ) 0%, rgba(21, 104, 60 ) 43%, rgba(21, 104, 60 ) 100%);",
  }),
}));

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 72,
  },
  // [`&.${stepConnectorClasses.active}`]: {
  //   [`& .${stepConnectorClasses.line}`]: {
  //     backgroundImage:
  //       "linear-gradient(0deg, rgba(184,0,200,1) 0%, rgba(161,0,175,1) 43%, rgba(184,0,200,1) 100%);",
  //   },
  // },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient(0deg, rgba(21, 104, 60 ) 0%, rgba(21, 104, 60 ) 43%, rgba(21, 104, 60 ) 100%);",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 5,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

function ColorlibStepIcon(props) {
  const { active, completed, className, icon, step } = props;

  if (icon === 1) {
    return (
      <ColorlibStepIconRoot
        ownerState={{ completed }}
        className={className}
        style={{
          // color: completed || active ? "#fff" : "black",
          color: completed ? "#fff" : "black",
          background:
            step === 1
              ? "#C20BCC"
              : step === 2
              ? "linear-gradient(0deg, rgba(21, 104, 60) 0%, rgba(21, 104, 60) 43%, rgba(21, 104, 60) 100%)" // ✅ Step 2 ใช้ Gradient
              : "#C20BCC",
          border: "1px dashed #b5b5b5",
        }}
      >
        1
      </ColorlibStepIconRoot>
    );
  }

  return (
    <ColorlibStepIconRoot
      // ownerState={{ completed, active }}
      ownerState={{ completed }}
      className={className}
      style={{
        // color: completed || active ? "#fff" : "black",
        color: completed ? "#fff" : "black",
        backgroundColor: "white",
        border: "1px dashed #b5b5b5",
      }}
    >
      {completed ? <CheckIcon /> : <>{props.icon}</>}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

const steps = [
  "New",
  "Review",
  "Submit for Verification",
  "In Approval Process",
  "Completed",
];

export default function ModalRegistrationForm(props) {
  const navigate = useNavigate();

  function closeModal() {
    props.onHide();
  }

  return (
    <div>
      <Modal
        ariaHideApp={false}
        isOpen={props.open}
        onRequestClose={closeModal}
        style={customStyles}
      >
        <Box>
          <Stepper
            alternativeLabel
            activeStep={2}
            connector={<ColorlibConnector />}
          >
            {steps.map((label) => (
              <Step key={label}>
                <Typography style={{ height: "50px" }}>{label}</Typography>
                <StepLabel StepIconComponent={ColorlibStepIcon}></StepLabel>
              </Step>
            ))}
          </Stepper>
          <br />

          <Typography variant="subtitle1">
            Thank you for your updated information in request number
          </Typography>
          <Typography variant="subtitle1">Your request number is</Typography>
          <Typography variant="inherit" style={{ fontWeight: "bold" }}>
            {props.request ? props.request : "No request id"}
          </Typography>
          <Typography variant="subtitle1">
            Please upload any updated documents if you have any.
          </Typography>
          <Typography variant="subtitle1">
            Your submission will take effect once
          </Typography>
          <Typography variant="subtitle1">
            the information has been confirmed.
          </Typography>
          <br />
          <Button
            variant="contained"
            onClick={() =>
              navigate("/upload-documents/" + props.fromId, {
                state: {
                  type: "post-on-boarding",
                },
              })
            }
          >
            OK
          </Button>
        </Box>
      </Modal>
    </div>
  );
}

const customStyles = {
  content: {
    top: "50%",
    left: "55%",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    width: "45%",
    height: "50%",
    zIndex: 999999,
  },
};
